import React from 'react'
import Modal from 'react-modal'
import { useFormik } from 'formik'
import { Button, FormGroup, FormInput, FormSelect } from 'shards-react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { COMMISSION_PLACES_EXPERT, COMMISSION_PLACES_GUK } from '../../../../constants/const'
import { commissionMemberAddActions, commissionMemberUpdateActions } from '../../../../redux/reducers/Commission/commissionReducer'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  mid: Yup.string().required('Выберите участника'),
})

const PLACE = {
  expert: COMMISSION_PLACES_EXPERT,
  guk: COMMISSION_PLACES_GUK
}

const modalStyles = {
  content: {
    inset: '15vh 30vw',
    padding: 0,
    borderRadius: '5px',
    overflow: 'visible',
  },
  overlay: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}


const initialValues = {
  mid: '',
  member_type: 'expert',
  place: 'member',
  position: '',
}

const AddMemberModal = ({ isOpen, closeModal, type, editData }) => {

  const isEdit = !!editData
  const { id } = useParams()
  const dispatch = useDispatch()
  const peoples = useSelector(state => state.commission.current.peoples)

  const formik = useFormik({
    initialValues: editData
      ? { mid: editData.mid, member_type: editData.member_type, place: editData.place, position: editData.position || '' }
      : initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      isEdit ? (
        dispatch(commissionMemberUpdateActions.commissionMemberUpdateRequestStart({ id: editData.id, position: values.position }))
      ) : (
        dispatch(commissionMemberAddActions.commissionMemberAddRequestStart({
          ...values,
          member_type: type,
          commission_id: id
        }))
      )
      resetForm()
      closeModal()
    },
  })

  const handleClose = () => {
    formik.resetForm()
    closeModal()
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div style={{ backgroundColor: '#4c6fb6', padding: '10px 15px', borderRadius: '5px 5px 0 0' }}>
        <span style={{ color: '#fff', fontSize: '15px', fontWeight: 500 }}>
          {isEdit ? 'Редактирование участника' : 'Добавление участника'}
        </span>
      </div>

      <form onSubmit={formik.handleSubmit} style={{ padding: '20px', display: 'flex', flexDirection: 'column', height: 'calc(100% - 41px)' }}>
        <FormGroup>
          <label>Выберите участника</label>
          <FormSelect
            name="mid"
            invalid={formik.touched.mid && !!formik.errors.mid}
            value={formik.values.mid}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isEdit}
          >
            <option value="">-- Выберите --</option>
            {peoples.map(p => (
              <option key={p.mid} value={p.mid}>
                {p.FIO}
              </option>
            ))}
          </FormSelect>
          {formik.touched.mid && formik.errors.mid && (
            <small style={{ color: '#c4183c' }}>{formik.errors.mid}</small>
          )}
        </FormGroup>

        <FormGroup>
          <label>Позиция</label>
          <FormSelect
            name="place"
            value={formik.values.place}
            onChange={formik.handleChange}
            disabled={isEdit}
          >
            {PLACE[type].map(p => (
              <option key={p.value} value={p.value}>{p.name}</option>
            ))}
          </FormSelect>
        </FormGroup>

        <FormGroup>
          <label>Должность</label>
          <FormInput
            type="text"
            name="position"
            placeholder="Введите должность"
            value={formik.values.position}
            onChange={formik.handleChange}
          />
        </FormGroup>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: 'auto', paddingTop: '15px' }}>
          <Button type="button" theme="light" onClick={handleClose}>Отменить</Button>
          <Button type="submit" theme="primary">{isEdit ? 'Сохранить' : 'Добавить'}</Button>
        </div>
      </form>
    </Modal>
  )
}

export default AddMemberModal
